import { Emblem } from "./Emblem";

export const CardBackArt = ({ label, tilt = 0, size = "card", bare = false }) => (
  <div className={`absolute inset-0 grid place-items-center ${bare ? "" : "bg-[radial-gradient(circle_at_50%_40%,#EDE6FB_0%,#F7F5FB_70%)]"}`} data-testid="card-back-art">
    <div style={{ rotate: `${tilt}deg` }}
      className={`relative aspect-[63/88] ${size === "lg" ? "w-[58%]" : "w-[64%]"} rounded-xl overflow-hidden bg-[#1B1430] border-[3px] border-[#F2C230] shadow-[0_24px_40px_-14px_rgba(110,63,184,.65)] transition-transform duration-500 group-hover:-translate-y-2 group-hover:rotate-0`}>
      <div className="absolute inset-1.5 rounded-lg border border-[#C9B6F2]/30 bg-[radial-gradient(circle_at_50%_45%,#6E3FB8_0%,#241A3A_55%,#120E1F_100%)]" />
      <div className="absolute inset-0 grid place-items-center"><Emblem className={size === "lg" ? "h-24 w-24" : "h-14 w-14"} /></div>
      <p className="absolute bottom-3 inset-x-0 text-center font-display text-[#C9B6F2] tracking-[0.2em] text-[10px]">JOLGEN</p>
      <div className="pack-shine absolute inset-0" />
    </div>
    {label && <span className="absolute top-3 right-3 badge-pill bg-[#120E1F] text-[#F2C230] uppercase tracking-[0.12em]">{label}</span>}
  </div>
);
